module.exports = __webpack_public_path__ + "img/delivery.7d73cd3e.png";